// Analytics Constants
export const GA_MEASUREMENT_ID = 'G-5KTYPZJH84'; 